/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choose_Renewal_PlanInputs */

const en_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose Renewal Plan
Continue Plus Benefits`)
};

const ar_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر خطة التجديد
حافظ على مزايا Plus`)
};

const de_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle deinen Tarif zur Verlängerung
Behalte deine Plus-Vorteile`)
};

const es_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige tu plan de renovación
Conserva tus beneficios Plus`)
};

const fr_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis ton offre de renouvellement
Conserve tes avantages Plus`)
};

const it_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli il piano di rinnovo
Mantieni i vantaggi Plus`)
};

const ja_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新プランを選択
Plus特典を継続`)
};

const ko_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`갱신 플랜 선택
Plus 혜택 계속 이용`)
};

const pt_br_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha seu plano de renovação
Continue com os benefícios Plus`)
};

const ru_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбери план продления
Сохрани преимущества Plus`)
};

const th_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกแผนต่ออายุ
ใช้สิทธิประโยชน์ Plus ต่อ`)
};

const tr_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yenileme planını seç
Plus avantajlarını koru`)
};

const zh_cn_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择续订方案
延续 Plus 权益`)
};

const zh_tw_choose_renewal_plan = /** @type {(inputs: Choose_Renewal_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇續訂方案
延續 Plus 權益`)
};

/**
* | output |
* | --- |
* | "Choose Renewal Plan Continue Plus Benefits" |
*
* @param {Choose_Renewal_PlanInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const choose_renewal_plan = /** @type {((inputs?: Choose_Renewal_PlanInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choose_Renewal_PlanInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_choose_renewal_plan(inputs)
	if (locale === "ar") return ar_choose_renewal_plan(inputs)
	if (locale === "de") return de_choose_renewal_plan(inputs)
	if (locale === "es") return es_choose_renewal_plan(inputs)
	if (locale === "fr") return fr_choose_renewal_plan(inputs)
	if (locale === "it") return it_choose_renewal_plan(inputs)
	if (locale === "ja") return ja_choose_renewal_plan(inputs)
	if (locale === "ko") return ko_choose_renewal_plan(inputs)
	if (locale === "pt_br") return pt_br_choose_renewal_plan(inputs)
	if (locale === "ru") return ru_choose_renewal_plan(inputs)
	if (locale === "th") return th_choose_renewal_plan(inputs)
	if (locale === "tr") return tr_choose_renewal_plan(inputs)
	if (locale === "zh_cn") return zh_cn_choose_renewal_plan(inputs)
	return zh_tw_choose_renewal_plan(inputs)
});